import styled from "styled-components";

import { breakpoints } from "Libs/theme";

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  padding: 24px;

  box-shadow: 0px 6px 24px
    var(--section-periwinkle-grey-box-shadow-color, var(--periwinkle-grey));

  @media (min-width: ${breakpoints[0]}) {
    justify-content: center;
  }
`;
